<template>
    <div
        class="search-result"
        :class="{ isActive: id === activeId}"
        @click.prevent="emit('click', resultUrl())"
    >
        <div class="header">
            Order #{{ data.order_no }} ({{ __('orders.show.id_internal') }} :{{ data.id }})
        </div>
        <div class="subline">
            Client: {{ data.client }}
        </div>
        <div class="subline">
            Status: {{ data.status }}
        </div>
    </div>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { orderDetailsRouteParams } from '~@/Mixins/orderNumber'

import { onUnmounted } from 'vue'

const props = defineProps({
    data: {
        type: Object,
        default: () => {
            return null
        }
    },
    id: {
        type: Number,
        default: () => {
            return null
        }
    },
    activeId: {
        type: Number,
        default: () => {
            return null
        }
    }
})

const emit = defineEmits(['click'])

window.addEventListener('keydown', handleKeys)
onUnmounted(() => {
    window.removeEventListener('keydown', handleKeys)
})

function resultUrl () {
    return route('orders.details', orderDetailsRouteParams(props.data))
}
function handleKeys (event) {
    // ENTER
    if (event.code === 'Enter') {
        emit('click', resultUrl())
    }
}
</script>

<style lang="scss" scoped>
.search-result {
    padding: 15px 25px;
    transition: 0.2s ease-in-out all;
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
    text-decoration: none;

    &:hover {
        background: rgba(0,0,0,0.07);
        cursor: pointer;
    }

    & .header {
        font-weight: bold;
        font-size: 16px;
        color: #222;
        background: transparent;
    }
    & .subline {
        color: rgba(0,0,0,0.6);
    }
}
.isActive {
    background: rgba(0,0,0,0.07);
}
</style>
